/* eslint-disable import/order */
import React from 'react';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import type ArchivedDirectLinkType from '@jira/project-pages__project-archive-archived-direct-link/src/ui/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { archivedProjectDirectLinkRoute } from '@jira/router-routes__archived-project-direct-link-routes/src/archivedProjectDirectLinkRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyArchivedDirectLink = lazyForPaint<typeof ArchivedDirectLinkType>(() =>
	markAsProductBundleReady(
		// eslint-disable-next-line jira/import/file-extension-required
		import(
			/* webpackChunkName: "async-project-archived-direct-link", jiraSpaEntry: "async-project-archived-direct-link" */ '@jira/project-pages__project-archive-archived-direct-link'
		),
	),
);

const ArchivedProjectDirectLink = () => (
	<LazyPage
		Page={LazyArchivedDirectLink}
		pageId="archived-project-direct-link"
		shouldShowSpinner={false}
	/>
);

export const archivedProjectDirectLinkRouteEntry: Route = createEntry(
	archivedProjectDirectLinkRoute,
	() => ({
		group: 'redirects',
		// eslint-disable-next-line no-restricted-syntax
		component: ArchivedProjectDirectLink,
		layout: globalLayout,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyArchivedDirectLink],
		ufoName: 'project-archived',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
